import { DesignerObjectType } from '../graphql-api-enums.ts';

export const isDesignerObjectType = (value: unknown): value is DesignerObjectType =>
  typeof value === 'string' && value in DesignerObjectType;

export const visualDesignerObjectTypeOrNull = (value: unknown): DesignerObjectType | null =>
  isDesignerObjectType(value) ? value : null;
